module.exports = __webpack_public_path__ + "img/EPF-24D-Goldregen-Model-Q-0817.9f745fd6.jpg";